<template>
  <div id="wrapper">
    <SiteHeader
      title="Donate Badges"
      description="Generate donation badges for your projects"
      logo="logo.png"
    />
    <nav id="nav">
      <ul>
        <li><a href="#intro" class="active">Introduction</a></li>
        <li><a href="#features">Feature</a></li>
        <li><a href="#stats">Stats</a></li>
        <li><a href="#start">Get Started</a></li>
      </ul>
    </nav>
    <div id="main">
      <section id="intro" class="main">
        <div class="spotlight">
          <div class="content">
            <header class="major">
              <h2>Generate easily</h2>
            </header>
            <p>
              With this tool, you can generate donation badges for your projects
              and use in Markdown documents, web pages, and more. It is
              completely <b>free</b>. Just a few click and you have your own
              badge.
            </p>
          </div>
          <span class="image"
            ><img src="../assets/images/donate-sample.png" alt=""
          /></span>
        </div>
      </section>
      <section id="features" class="main special">
        <header class="major">
          <h2>Features</h2>
        </header>
        <ul class="features">
          <li>
            <span class="icon solid major style1 fa-file-code"></span>
            <h3>Markdown</h3>
            <p>
              You can use generated badge in your MD files easily with a
              copy/paste command. The final script is simple.
            </p>
          </li>
          <li>
            <span class="icon solid major style3 fa-qrcode"></span>
            <h3>QR Code</h3>
            <p>
              There is a QR code for your badge. You can use it in your
              webpages, emails, social networks, etc.
            </p>
          </li>
          <li>
            <span class="icon solid major style5 fa-pager"></span>
            <h3>Donate Page</h3>
            <p>
              Your links are automatically come here and will show a donate page
              to your clients.
            </p>
          </li>
        </ul>
      </section>
      <section id="stats" class="main special">
        <header class="major">
          <h2>Donate Badges stats</h2>
          <p>You can see the stats of generated badges here.</p>
        </header>
        <ul class="statistics">
          <li class="style1">
            <span class="icon solid fa-calendar-day"></span>
            <strong>{{ reports.day }}</strong> Today
          </li>
          <li class="style2">
            <span class="icon solid fa-calendar"></span>
            <strong>{{ reports.month }}</strong> Monthly
          </li>
          <li class="style3">
            <span class="icon solid fa-signal"></span>
            <strong>{{ reports.total }}</strong> Total Badges
          </li>
          <li class="style4">
            <span class="icon solid fa-link"></span>
            <strong>{{ reports.link }}</strong> Links
          </li>
          <li class="style5">
            <span class="icon solid fa-coins"></span>
            <strong>{{ reports.crypto }}</strong> Crypto
          </li>
        </ul>
      </section>
      <section id="start" class="main special">
        <header class="major">
          <h2>Get Started</h2>
          <p>
            Are you ready? Just click the button below and start generating
            awesome badges
          </p>
        </header>
        <footer class="major">
          <ul class="actions special">
            <li>
              <router-link class="button primary" to="/generate"
                >Let's go</router-link
              >
            </li>
          </ul>
        </footer>
      </section>
    </div>
    <SiteFooter />
  </div>
</template>

<script>
import $ from "jquery";
import "@/assets/js/jquery.scrollex.min.js";
import "@/assets/js/jquery.scrolly.min.js";
import browser from "@/assets/js/browser.min.js";
import breakpoints from "@/assets/js/breakpoints.min.js";
import "@/assets/js/util.js";

import SiteHeader from "@/components/HeaderSection.vue";
import SiteFooter from "@/components/FooterSection.vue";

export default {
  name: "HomeView",
  components: { SiteHeader, SiteFooter },
  data() {
    return {
      reports: {
        day: "-",
        month: "-",
        total: "-",
        crypto: "-",
        link: "-",
      },
    };
  },
  mounted() {
    var $window = $(window),
      $body = $("body"),
      $main = $("#main");

    // Breakpoints.
    breakpoints({
      xlarge: ["1281px", "1680px"],
      large: ["981px", "1280px"],
      medium: ["737px", "980px"],
      small: ["481px", "736px"],
      xsmall: ["361px", "480px"],
      xxsmall: [null, "360px"],
    });

    // Play initial animations on page load.
    $window.on("load", function () {
      window.setTimeout(function () {
        $body.removeClass("is-preload");
      }, 100);
    });

    // Navbar
    var $nav = $("#nav");

    if ($nav.length > 0) {
      // Shrink effect
      $main.scrollex({
        mode: "top",
        enter: function () {
          $nav.addClass("alt");
        },
        leave: function () {
          $nav.removeClass("alt");
        },
      });

      // Links
      var $nav_a = $nav.find("a");

      $nav_a
        .scrolly({
          speed: 1000,
          offset: function () {
            return $nav.height();
          },
        })
        .on("click", function () {
          var $this = $(this);

          // External link? Bail.
          if ($this.attr("href").charAt(0) != "#") return;

          // Deactivate all links.
          $nav_a.removeClass("active").removeClass("active-locked");

          // Activate link *and* lock it (so Scrollex doesn't try to activate other links as we're scrolling to this one's section).
          $this.addClass("active").addClass("active-locked");
        })
        .each(function () {
          var $this = $(this),
            id = $this.attr("href"),
            $section = $(id);

          // No section for this link? Bail.
          if ($section.length < 1) return;

          // Scrollex.
          $section.scrollex({
            mode: "middle",
            initialize: function () {
              // Deactivate section.
              if (browser.canUse("transition")) $section.addClass("inactive");
            },
            enter: function () {
              // Activate section.
              $section.removeClass("inactive");

              // No locked links? Deactivate all links and activate this section's one.
              if ($nav_a.filter(".active-locked").length == 0) {
                $nav_a.removeClass("active");
                $this.addClass("active");
              }

              // Otherwise, if this section's link is the one that's locked, unlock it.
              else if ($this.hasClass("active-locked"))
                $this.removeClass("active-locked");
            },
          });
        });

      this.axios.get("/api/reports").then((response) => {
        if (response.status === 200) {
          this.reports.day = response.data.Day;
          this.reports.month = response.data.Month;
          this.reports.total = response.data.Total;
          this.reports.link = response.data.Links;
          this.reports.crypto = response.data.Crypto;
        } else {
          console.error("Failed to load reports");
        }
      });
    }
  },
};
</script>
